import { Global } from '@vimeo/bokeh';
import { browserConfig } from '@vimeo/live-core/configs/BrowserConfig';

export function InteractionToolsResponsiveScaling() {
  if (browserConfig.IS_IN_IFRAME) {
    return (
      <Global
        styles={{
          '@media (max-width: 375px)': {
            ':root': {
              fontSize: '14px',
            },
          },

          '@media (max-width: 300px)': {
            ':root': {
              fontSize: '12px',
            },
          },
        }}
      />
    );
  }

  return null;
}
